import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const ContactSection = () => {
  return (
    <section className="bg-white py-16 px-4 md:px-8 shadow-inner rounded-t-2xl">
      <div className="container mx-auto text-center">
        <h2 className="text-4xl font-extrabold text-gray-900 mb-10 leading-tight">
          Liên Hệ Chúng Tôi
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 max-w-6xl mx-auto">
          <div className="flex flex-col items-center p-6 bg-blue-50 rounded-lg shadow-sm">
            <MapPin size={32} className="text-blue-600 mb-3" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Địa Chỉ
            </h3>
            <p className="text-gray-600">Xã Vĩnh Lộc, TP. Hồ Chí Minh</p>
          </div>
          <div className="flex flex-col items-center p-6 bg-green-50 rounded-lg shadow-sm">
            <Phone size={32} className="text-green-600 mb-3" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Điện Thoại
            </h3>
            <p className="text-gray-600">097.456.9396</p>
          </div>
          <div className="flex flex-col items-center p-6 bg-purple-50 rounded-lg shadow-sm">
            <Mail size={32} className="text-purple-600 mb-3" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Email</h3>
            <p className="text-gray-600">trungtammayxanh@gmail.com</p>
          </div>
          <div className="flex flex-col items-center p-6 bg-yellow-50 rounded-lg shadow-sm">
            <Clock size={32} className="text-yellow-600 mb-3" />
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              Giờ Làm Việc
            </h3>
            <p className="text-gray-600">Thứ 2 - 7: 8h - 17h</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
